import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Grid, Box, Typography, Card } from "@mui/material";
import { BACKUPINFO } from "../../services/actions";
import ProgressBar from "../extra/ProgressBar";

function Info({ data }) {
  return (
    <Card sx={{ p: 3, borderRadius: 8, boxShadow: 0 }}>
      <Box display={'flex'}>
        <Box sx={{ width: 1 }}>
          <Typography fontWeight={800} fontSize={13}>{data.camera}</Typography>
          <Typography fontWeight={700} fontSize={12}>{data.project}</Typography>
          <Typography fontWeight={700} fontSize={11}>{data.company}</Typography>
          <Typography fontSize={12} mt={2}>{data?.year}-{data?.month}-{data?.day}</Typography>
          <Typography fontSize={11}>{data?.source_size_mb} MB</Typography>
        </Box>
        <Box>
          <Typography className="toggle-status" sx={{
            p: 0.5,
            borderRadius: 2,
            color: 'white',
            background: data?.status === 'pending' ? '#c91d1d' : 'green',
            textAlign: 'center'
          }} fontSize={10} mb={2}>
            {data?.status}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}

export default function Dashboard() {
  const dispatch = useDispatch();
  const backupState = useSelector((state) => state.backupinfoState);
  const [page, setPage] = useState(0);
  const [statusMap, setStatusMap] = useState({ pendingCount: 0, completedCount: 0 });

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  const monthsL3 = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [availableYears, setAvailableYears] = useState([]);
  const [availableMonths, setAvailableMonths] = useState([]);
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeYearMonth = () => {
    setLoading(true);
    setDatas([]);
    fetchNext(1, 1);
  };

  useEffect(() => {
    const years = [];
    for (let i = 0; i < 10; i++) {
      years.push(currentYear - i);
    }
    setAvailableYears(years);
  }, [currentYear]);

  useEffect(() => {
    const maxMonth = selectedYear === currentYear ? currentMonth : 12;
    const monthsToShow = months.slice(0, maxMonth);
    setAvailableMonths(monthsToShow);

    if (selectedMonth > maxMonth) {
      setSelectedMonth(maxMonth);
    }
    onChangeYearMonth();
  }, [selectedYear, selectedMonth]);

  useEffect(() => {
    // recalculate status counts when datas change
    let pendingCount = 0;
    let completedCount = 0;

    datas.forEach(data => {
      if (data.status === "pending") pendingCount++;
      if (data.status === "completed") completedCount++;
    });

    setStatusMap({ pendingCount, completedCount });
  }, [datas]);

  const fetchNext = (pageArg, totalPage) => {
    if (!pageArg) return;
    if (totalPage && pageArg > totalPage) {
      setLoading(false);
      return;
    }

    let ml = monthsL3[selectedMonth - 1];
    dispatch({
      type: `${BACKUPINFO}_GET`,
      payload: `backup_reports/0/?year=${selectedYear}&month=${ml}&page=${pageArg}`,
      callback: (resp) => {
        let totalPage = resp?.pagination.total_pages;
        setDatas(prev => [...prev, ...resp?.results]);
        setTimeout(() => {
          setPage((prev) => {
            const nextPage = pageArg + 1;
            fetchNext(nextPage, totalPage);
            return nextPage;
          });
        }, 300);
      }
    });
  };

  return (
    <Container maxWidth="xl" sx={{ py: 2 }}>
      <h1>Backup Information</h1>
      {loading ? <ProgressBar /> :
        <Box sx={{ background: '#000', p: 1, borderRadius: 2, mb: 2, display: 'flex', gap: 3, alignItems: 'center',flexWrap:'wrap' }}>
          <Box sx={{display: 'flex', gap: 3, alignItems: 'center' }}>
            <Box sx={{ minWidth: 100 }}>
              <label>
                <Typography fontSize={11}> Select Year</Typography>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                >
                  {availableYears.map((year) => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </label>
            </Box>
            <Box sx={{ minWidth: 100 }}>
              <label>
                <Typography fontSize={11}> Select Month</Typography>
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
                >
                  {availableMonths.map((month, index) => (
                    <option key={index} value={index + 1}>{month}</option>
                  ))}
                </select>
              </label>
            </Box>
          </Box>
          <Box sx={{ color: 'blue' }}>Total: {backupState?.data?.pagination?.total_items}</Box>
          <Box sx={{ color: 'red' }}>Pending: {statusMap.pendingCount}</Box>
          <Box sx={{ color: 'green' }}>Completed: {statusMap.completedCount}</Box>
        </Box>}



      <Grid container spacing={2} my={2}>
        {(datas || []).map((data, i) => (
          <Grid className="toggle-card" size={{ xs: 12, md: 4 }} key={i}>
            <Info data={data} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
